module.exports = __webpack_public_path__ + "static/media/im-11.da6e69f5.png";